import Typography from '@mui/material/Typography'
import { styled } from '@mui/material'

export const AlertText = styled(Typography)(theme => ({
	textAlign: 'center',
	margin: '24px',
	fontSize: '14px',
	lineHeight: '17px',
}))
